import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
// import { fetchTeamsInfo, fetchGoals, fetchTeams } from "../api";
import { fetchTeamsInfo, fetchGoals, fetchTeams, fetchTable } from "../api";

function TeamDetail() {
  const { teamName } = useParams();
  const [teamInfo, setTeamInfo] = useState(null);
  const [topScorer, setTopScorer] = useState(null);
  const [tableInfo, setTableInfo] = useState(null);

  useEffect(() => {
    fetchTeamsInfo().then((res) => {
      const info = res.data.find((t) => t.team_name === teamName);
      setTeamInfo(info);
    });

    fetchTeams().then((res) => {
      const team = res.data.find((t) => t.team_name === teamName);
      if (!team) return;

      fetchGoals().then((res) => {
        const teamGoals = res.data.filter(
          (g) => g.team_code === team.team_code,
        );
        const counts = {};
        teamGoals.forEach((g) => {
          if (g.scorer_name)
            counts[g.scorer_name] = (counts[g.scorer_name] || 0) + 1;
        });
        const top = Object.entries(counts).sort((a, b) => b[1] - a[1])[0];
        setTopScorer(top ? { name: top[0], goals: top[1] } : null);
      });
    });

    fetchTable().then((res) => {
      const row = res.data.find((t) => t.Team === teamName);
      setTableInfo(row);
    });
  }, [teamName]);

  if (!teamInfo) return <div className="container">Loading...</div>;

  return (
    <div className="container">
      <div className="text-center mb-4">
        <img
          src={`/badges/${teamName}.png`}
          alt={teamName}
          style={{ width: "150px", height: "150px", objectFit: "contain" }}
        />
        <h1 className="fw-bold mt-3">{teamName}</h1>
        <p>Established: {teamInfo.established}</p>
        <p>Stadium: {teamInfo.stadium}</p>
        <p>Capacity: {teamInfo.capacity}</p>
      </div>

      <div className="row justify-content-center g-3 mb-4">
        <div className="col-md-3">
          <div className="card shadow-sm text-center">
            <div className="card-body">
              <h5
                className="card-title text-white p-2 rounded-top"
                style={{ backgroundColor: "#1A56DB" }}
              >
                Top Scorer
              </h5>
              <p className="mb-1 mt-3 fs-5">
                {topScorer ? topScorer.name : "N/A"}
              </p>
              <p className="fs-4 fw-bold">
                {topScorer ? topScorer.goals : 0} goals
              </p>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card shadow-sm text-center">
            <div className="card-body">
              <h5
                className="card-title text-white p-2 rounded-top"
                style={{ backgroundColor: "#1A56DB" }}
              >
                Final Position
              </h5>
              <p className="fs-1 fw-bold mt-3">
                {tableInfo ? tableInfo.Pos : "-"}
              </p>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card shadow-sm text-center">
            <div className="card-body">
              <h5
                className="card-title text-white p-2 rounded-top"
                style={{ backgroundColor: "#1A56DB" }}
              >
                Wins
              </h5>
              <p className="fs-1 fw-bold mt-3">
                {tableInfo ? tableInfo.W : "-"}
              </p>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card shadow-sm text-center">
            <div className="card-body">
              <h5
                className="card-title text-white p-2 rounded-top"
                style={{ backgroundColor: "#1A56DB" }}
              >
                Goals Scored
              </h5>
              <p className="fs-1 fw-bold mt-3">
                {tableInfo ? tableInfo.GF : "-"}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="text-center mt-4">
        <Link to="/teams" className="btn btn-secondary">
          ← Back to Teams
        </Link>
      </div>
    </div>
  );
}

export default TeamDetail;
